/**
 * @param {Observable<[player.currentTime, Config, Playback, player.Playback]>} resumePointsTrigger$
 * @param {Observable}
 */

const INT_RADIX = 10;
const calculatePosition = (time, minTime) => parseInt(time - minTime, INT_RADIX);

const subscribeToResumePointsTrigger = (
    resumePointsTrigger$,
    resumePointsApiRequest$
) =>
    resumePointsTrigger$
        .subscribe(([
            currentTime,
            latestConfig,
            latestPlayback,
            latestPlayerPlayback,
        ]) => {
            const { minTime, maxTime } = latestPlayerPlayback;
            const { authToken } = latestConfig.environment;
            const { asset, media } = latestPlayback;

            const requestData = {
                assetId: asset.id,
                articleTypeId: asset.type.id,
                contentLength: calculatePosition(maxTime, minTime),
                position: calculatePosition(currentTime, minTime),
                videoType: media.videoType,
                eventId: asset.eventId,
                authToken,
            };

            resumePointsApiRequest$.next(requestData);
        });

export default subscribeToResumePointsTrigger;

